import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { MensagensService } from 'max-ng-lib';

import { environment } from '../../../../environments/environment';
import { ValidacaoHelper } from '../../../../utils/validacao-helper';

@Component({
	selector: "m-acesso-restrito",
	templateUrl: "./acesso-restrito.component.html",
	styleUrls: ["./acesso-restrito.component.scss"],
})
export class AcessoRestritoComponent implements OnInit {
	senha: string;
	validacaoHelper: ValidacaoHelper;
	constructor(
		public mensagens: MensagensService,
		public dialogRef: MatDialogRef<AcessoRestritoComponent>
	) {
		this.validacaoHelper = new ValidacaoHelper(mensagens);
	}

	ngOnInit() {}

	fechar() {
		this.dialogRef.close("closed");
	}

	acessar() {
		if (this.senha === environment.SENHA_ADMIN) {
			this.dialogRef.close("authorized");
		} else {
			this.validacaoHelper.setFocoNoElementoDaClasseEExibeMensagem(
				"senha",
				"Senha inválida!"
			);
		}
	}
}
